import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupFormComponent } from '../../ui/signup-form/signup-form.component';
import { Subject, takeUntil } from 'rxjs';
import { SignUpRequest, CommunicationType, ReceiverDet } from '../../interfaces/signUp.interface';
import { SignUpService } from '../../data-access/signup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'equine-ui-nx-signup-form',
  standalone: true,
  imports: [CommonModule, SignupFormComponent],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss',
})

export class SignupComponent implements OnInit, OnDestroy{

  unsubscribe$ = new Subject<void>();
  loading = false;
  isEmailExists = false;
  isMobileExists = false;
  subscription: any;
  queryParams: any;
  invitationId: any;
  formData: any;
  appName!: string;
  constructor(
    private signUpService: SignUpService,
    private router: Router,
    private snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
  ){}

  ngOnInit(): void {
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (params: any) => {
        if (params['fromDonation']) {
          this.getDonationData(params['fromDonation']);
        } else {
          this.queryParams = JSON.parse(JSON.stringify(params));
          this.invitationId = this.queryParams.invitationId;
          if(this.invitationId) {
            this.fetchInvitationDetails();
          }
        }
      }
    );
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName;
    })
  }

  signUp(signupData: SignUpRequest) {
    const payload = {
      ...signupData,
      invitationId: this.invitationId,
      roleId: this.formData?.role?._id,
      appName: this.appName
    }
    this.signUpService
      .signup(payload)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data)=> {
          if(data.status) {
            localStorage.setItem('signup-email', '' + signupData.email);
            this.router.navigate(['account','signup-success']);
          } else {
            const signupError = 'Unable to create account';
            this.showError(signupError);
          }
          this.loading = false;
        },
        error: (err)=> {
          this.loading = false;
          const signupError = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
          this.showError(signupError);
        }
      })
  }

  checkEmailOMobileExists(receiverDet: ReceiverDet) {
    const communicationType: CommunicationType = receiverDet.communicationType;
    const receiver: string = receiverDet.receiver;
    this.loading = true;
    if(communicationType === CommunicationType.EMAIL) {
      this.isEmailExists = false;
    } else {
      this.isMobileExists = false;
    }
    this.signUpService
      .isEmailMobileUnique(communicationType, receiver, this.appName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          this.loading = false;
          if(data.status) {
            if(communicationType === CommunicationType.EMAIL) {
              this.isEmailExists = true;
            } else {
              this.isMobileExists = true;
            }
          } else {
            if(communicationType === CommunicationType.EMAIL) {
              this.isEmailExists = false;
            } else {
              this.isMobileExists = false;
            }
          }
        },
        error: (err) => {
          this.loading = false;
          if(communicationType === CommunicationType.EMAIL) {
            this.isEmailExists = true;
          } else {
            this.isMobileExists = true;
          }
          const errorMessage = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
          this.showError(errorMessage);
        }
      })
  }

  showError(errorMsg: string) {
    if(!errorMsg) {
      errorMsg = 'Internal Server error';
    }
    this.snackBar.open(`Error: ${errorMsg}`, 'Dismiss', {duration: 3000, panelClass:['error-snackbar']});
  }

  navigateToPage(url: string[]): void {
    this.router.navigate(url);
  }

  fetchInvitationDetails() {
    this.signUpService.fetchInvitationData(this.invitationId).pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (res: any) => {
        if(res?.status) {
          this.formData = res?.data;
        }
      },
      error: (err: any) => {
        this.showError(err.error.message[0]);
      }
    })
  }

  getDonationData(donationId: string) {
    this.signUpService.getDonation(donationId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (donation: any) => {
          if(donation) {
            const dataMapped = {
              firstName: donation.firstName,
              lastName: donation.lastName,
              email: donation.email,
              confirmEmail: donation.email,
              phoneNumber: donation.phoneNumber
            }

            this.formData = dataMapped;
          }
        },
        error: (err: any) => {
          this.showError(err.error.message[0]);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
